import { createSlice } from '@reduxjs/toolkit';
import { IArticleData } from './article/getAllArticleSlice';

export interface MenteeQuestion {
  _id?: any;
  menteeQues: string;
  menteeAnsType: string;
  isAddedNewly?: boolean;
}
export interface IAdminTask {
  tags?: string[];
  taskName?: string;
  status?: string;
  taskDescription?: string;
  menteeQuestions?: MenteeQuestion[];
  mentorAnswers?: any[];
  taskPosition?: number;
  maxMenteeAns?: number;
  minMenteeAns?: number;
  menteeAsmtQues?: string;
  menteeAsmtAnsType?: string;
  menteeAsmtAnsOptions?: string[];
  libraryArticles?: any;
  _id?: string;
  error?: boolean;
  topics?: string[];
  isNewTask?: boolean;
  startDate?: any;
  endDate?: any;
  MCQ?: {
    ques: string;
    options: string[];
    isNew?: boolean;
    _id: string;
    correctAnswerIndex?: number;
    correctAns: any;
    encryptedAns?: any;
  }[];
}

export interface ITaskLevels {
  levelName: string;
  level: number;
  _id?: string;
  tasks: IAdminTask[];
  isLevelAdd?: boolean;
  isTaskAdd?: boolean;
  isNewLevel?: boolean;
  levelDescription?: string;
  status?: string;
  startDate?: {
    type: string;
    value: number;
  };
  endDate?: {
    type: string;
    value: number;
  };
}

export interface IDeletion {
  levelId: string;
  tasks: string[];
}

export interface ITaskData {
  goalName: string;
  levels: ITaskLevels[];
  programType: string;
  _id?: string;
  deletions?: IDeletion[];
}

export interface IInitialTaskState {
  data: ITaskData | null;
}

const initialState: IInitialTaskState = {
  data: null
};

const tasksSlice = createSlice({
  name: 'admin tasks',
  initialState,
  reducers: {
    updateTasks: (state, action) => {
      state.data = action.payload;
    },
    updateGoalName: (state, action) => {
      if (state.data) {
        state.data.goalName = action.payload;
      }
    }
  }
});

export default tasksSlice.reducer;
export const adminTaskActions = tasksSlice.actions;
